// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__u3LK5","container":"styles_container__6TrQP"};